import { render, staticRenderFns } from "./IndicadorPeriodo.vue?vue&type=template&id=13ed4297&scoped=true"
import script from "./IndicadorPeriodo.vue?vue&type=script&lang=js"
export * from "./IndicadorPeriodo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ed4297",
  null
  
)

export default component.exports